import React, { useState } from "react";
import type { RouteComponentProps } from "@gatsbyjs/reach-router";
import { useRacingEvents } from "@/hooks/firestore/v2/betting/useRacingEvents";
import { NextToJumpSkeleton } from "@/features/racing/components/Tabs/NextToJumpSkeleton";
import useRestoreScrollPosition from "@/hooks/useRestoreScrollPosition";
import { PageMessage } from "@/components/PageMessage";
import { Box } from "@/components/Box";
import { RaceRow } from "@/features/racing/components/RaceRow";
import { useSearchParams } from "@/hooks/useSearchParams";
import { racingFilters } from "@/features/racing/models/racingFilters";
import { LoadMore } from "@/components/LoadMore";
import { useTitleOverride } from "@/features/racing/hooks/useTitleOverride";

import { ReactComponent as OddsUnavailable } from "components/assets/icon-empty-odds.svg";

const NextToJump = (_: RouteComponentProps) => {
  const {
    searchParams: { page, regions, titles },
    setSearchParams,
  } = useSearchParams(racingFilters);

  const forcedTitles = useTitleOverride();

  const { events, isLoading } = useRacingEvents({
    page,
    regions,
    titles: forcedTitles.length > 0 ? forcedTitles : titles,
    status: "OPEN",
  });
  useRestoreScrollPosition(isLoading);

  if (isLoading) {
    return <NextToJumpSkeleton count={50} />;
  }

  if (!events) {
    // no races available at the time
    return (
      <PageMessage
        title="Races Unavailable"
        image={<OddsUnavailable />}
        subTitle="There are currently no races which match your filters"
      />
    );
  }

  return (
    <>
      <Box noChildrenSpace hideHeader>
        {events.map((event) => (
          <RaceRow key={`race-${event.id}`} event={event} />
        ))}
      </Box>

      <LoadMore
        hasMore={page * 50 <= events?.length}
        next={() => {
          setSearchParams({
            page: page + 1,
          });
        }}
      />
    </>
  );
};

export { NextToJump };
